import { createSlice } from '@reduxjs/toolkit'

// Review this reducer, why 2 states

const wallets = createSlice({
  name: 'wallets',
  initialState: {
    walletDirection: {
      polygonAddress: null,
      tronAddress: null,
      isLoading: true,
      error: null,
    },
    wallets: {
      data: null,
      isLoading: true,
      error: null,
    },
  },
  reducers: {
    setWalletDirection: (state, action) => {
      state.walletDirection.polygonAddress = action.payload.polygonAddress
      state.walletDirection.tronAddress = action.payload.tronAddress
      state.walletDirection.isLoading = action.payload.isLoading
      state.walletDirection.error = action.payload.error
    },
    setWallets: (state, action) => {
      state.wallets.data = action.payload.wallets
      state.wallets.isLoading = action.payload.isLoading
      state.wallets.error = action.payload.error
    },
  },
})

export const { setWallets, setWalletDirection } = wallets.actions
export default wallets.reducer
